import axiosInstance from '../../services/http.api';
import { DEFAULT_ERROR_MSG} from '../../utils/constants';
import { BannerData, BannerConstants} from './banner.types';


export const bannerService = {

  /**
   * Fetch Banners
   * @returns 
   */
  fetchBanners: async (): Promise<BannerData[]> => {
    try {
      const res = await axiosInstance.get<any>(`/v1/Banner`);

      if (!res.data.success) {
        throw new Error(res.data.message || BannerConstants.ERROR_FETCH_BANNER);
      }

      let data = res.data.data || [];

      const banners: BannerData[] = data.map((banner: any) => ({
        id: banner.id,
        firstName: banner.message,
        startDate: banner.startDate,
        endDate: banner.endDate,
        message: banner.message,
        visibility: banner.visibility
      }));
      return banners;
    } catch (error: any) {
      console.log(error);
      throw new Error(error?.response?.data?.message || BannerConstants.ERROR_FETCH_BANNER);
    }
  },

/**
 * Create Banner
 * @param banner 
 * @returns 
 */
  addBanner: async (banner: BannerData): Promise<BannerData> => {
    try {
      
      const bannerDataRequest = {'id':"530b4d9b-8231-4732-8177-ed35777e58d8", 'message': banner.message, 'startDate': banner.startDate, 'endDate': banner.endDate, "visibility": banner.visibility};

      const res = await axiosInstance.post<any>('/v1/Banner', bannerDataRequest);

      if (!res.data.success) {
        throw new Error(res.data.message || BannerConstants.ERROR_ADD_BANNER);
      }

      let bannerResonse = res.data.data || {};

      const bannerDataResonse: BannerData = {
        id: bannerResonse.id,
        message: bannerResonse.message,
        startDate: bannerResonse.startDate,
        endDate: bannerResonse.endDate,
        visibility: bannerResonse.visibility
      };

      return bannerDataResonse;

    } catch (error: any) {
      throw new Error(error?.response?.data?.errors?.Message || BannerConstants.ERROR_ADD_BANNER);
    }
  },

/**
 * Update Banner
 * @param banner 
 * @returns 
 */
  updateBanner: async (banner: BannerData): Promise<BannerData> => {
    try {
     
      const bannerDataRequest = { 'id': banner.id, 'message': banner.message, 'startDate': banner.startDate, 'endDate': banner.endDate, "visibility": banner.visibility};

      const res = await axiosInstance.post<any>('/v1/Banner', bannerDataRequest);

      if (!res.data.success) {
        throw new Error(res.data.message || BannerConstants.ERROR_UPDATE_BANNER);
      }

      let bannerResonse = res.data.data || {};

      const bannerDataResonse: BannerData = {
        id: bannerResonse.id,
        message: bannerResonse.message,
        startDate: bannerResonse.startDate,
        endDate: bannerResonse.endDate,
        visibility: bannerResonse.visibility
      };

      return bannerDataResonse;
    } catch (error: any) {
      throw new Error(error?.response?.data?.errors?.Message || BannerConstants.ERROR_UPDATE_BANNER);
    }
  },

  /**
   * Delete Banner
   * @param banner
   * @returns 
   */
  deleteBanner: async (banner: BannerData[]): Promise<any> => {
    try {
      const res = await axiosInstance.delete(`/v1/User/${banner[0].id}`);

      if (!res.data.isSuccess) {
        // Throw an error with custom message
        throw new Error(res.data.message || DEFAULT_ERROR_MSG);
      }
      return banner[0];
    } catch (error: any) {
      throw new Error(error?.response?.data?.errors?.Message || BannerConstants.ERROR_DELETE_BANNER);
    }
  },

/**
 * Delete multiple banners
 * @param users 
 * @returns 
 */
  bulkDeleteBanners: async (banners: BannerData[]): Promise<any> => {
    try {
      const userIds = banners.map(banner => banner.id);
      const payload = {
        userIds: userIds,
        maxConcurrency: 0,
      };

      const res = await axiosInstance.delete("/v1/User/bulk", {
        data: payload
      });

      if (!res.data.isSuccess) {
        // Throw an error with custom message
        throw new Error(res.data.message || DEFAULT_ERROR_MSG);
      }
      return res.data.results;
    } catch (error: any) {
      throw new Error(error?.response?.data?.errors?.Message || BannerConstants.ERROR_DELETE_BANNER);
    }
  }
}